import { render, staticRenderFns } from "./ScormLogo.vue?vue&type=template&id=4a376cde&"
import script from "./ScormLogo.vue?vue&type=script&lang=ts&"
export * from "./ScormLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports